import './Homepage.scss';
ComponentManager.init(document.body);